(function () {
  'use strict';

  var initialized = false;

  function getYouTubeId(url) {
    if (!url) return null;

    try {
      var value = String(url).trim();

      if (value.indexOf('//') === 0) {
        value = window.location.protocol + value;
      }

      var u = new URL(value, window.location.href);
      var host = u.hostname.replace(/^www\./, '').toLowerCase();

      if (host === 'youtu.be') {
        return u.pathname.replace(/^\/+/, '').split('/')[0] || null;
      }

      if (host === 'youtube.com' || host === 'm.youtube.com') {
        if (u.pathname === '/watch') {
          return u.searchParams.get('v');
        }

        if (u.pathname.indexOf('/embed/') === 0) {
          return u.pathname.split('/')[2] || null;
        }

        if (u.pathname.indexOf('/shorts/') === 0) {
          return u.pathname.split('/')[2] || null;
        }
      }
    } catch (e) {
      /* Ignore malformed URLs. */
    }

    /* Fallback for old-style strings. */
    var match = String(url).match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([^?&/"' ]+)/i
    );

    return match ? match[1] : null;
  }

  function getMediaUrl(element) {
    if (!element) return '';

    return (
      element.getAttribute('src') ||
      element.getAttribute('data-src') ||
      element.getAttribute('data-lazy-src') ||
      ''
    );
  }

  function getLabelFromText(text) {
    if (!text) return null;

    var match = String(text).match(/\b(A[1-4]|B[1-4])\b/i);
    return match ? match[1].toUpperCase() : null;
  }

  /*
   * Try to identify the track label immediately associated with an iframe.
   * We deliberately look locally first so a whole-description "A1" does not
   * accidentally get assigned to every iframe.
   */
  function findNearbyLabel(element) {
    var node = element;

    for (var level = 0; level < 4 && node; level++) {
      var sibling = node.previousElementSibling;

      for (var count = 0; count < 5 && sibling; count++) {
        var text = sibling.textContent || '';
        var label = getLabelFromText(text);

        if (label) return label;

        sibling = sibling.previousElementSibling;
      }

      var parent = node.parentElement;
      if (parent) {
        var parentText = parent.textContent || '';
        /* Only inspect reasonably small containers. */
        if (parentText.length <= 250) {
          var parentLabel = getLabelFromText(parentText);
          if (parentLabel) return parentLabel;
        }
      }

      node = node.parentElement;
    }

    return null;
  }

  function collectDescriptionSources(description) {
    var sources = [];
    var usedIds = {};

    if (!description) return sources;

    var elements = description.querySelectorAll(
      'iframe, a[href], [data-src], [data-lazy-src]'
    );

    elements.forEach(function (element) {
      var url = getMediaUrl(element) || element.getAttribute('data-eb-original-src') || '';

      if (!url && element.tagName === 'A') {
        url = element.getAttribute('href') || '';
      }

      var id = getYouTubeId(url);

      /* SoundCloud is intentionally detected only so its iframe can be
         hidden after reading. It is not used as a YouTube playback source. */
      var isSoundCloud = /soundcloud\.com/i.test(url);

      if (!id && !isSoundCloud) return;

      if (isSoundCloud) {
        element.setAttribute('data-eb-hidden-embed', 'true');
        return;
      }

      if (usedIds[id]) {
        element.setAttribute('data-eb-hidden-embed', 'true');
        return;
      }

      usedIds[id] = true;

      sources.push({
        id: id,
        url: url,
        label: findNearbyLabel(element),
        element: element
      });
    });

    return sources;
  }

  function hideOriginalEmbed(element) {
    if (!element) return;
    if (element.tagName === 'IFRAME' && !element.getAttribute('data-eb-original-src')) {
      var originalSrc = element.getAttribute('src') || '';
      if (originalSrc) {
        element.setAttribute('data-eb-original-src', originalSrc);
        element.removeAttribute('src');
      }
    }
    element.setAttribute('data-eb-original-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
  }

  function assignSources(container) {
    var description = container.closest('.product__info-container')
      ? container.closest('.product__info-container').querySelector('.product__description')
      : document.querySelector('.product__description');

    if (!description) return [];

    var sources = collectDescriptionSources(description);

    /*
     * First pass: assign sources that have an explicit A1/B1/etc label.
     * Second pass: assign any unlabeled sources sequentially to the first
     * available player slot. This keeps the system working even when the
     * HTML generated by Shopify strips the surrounding label structure.
     */
    var tracks = Array.prototype.slice.call(
      container.querySelectorAll('[data-track]')
    );

    var trackByLabel = {};
    tracks.forEach(function (track) {
      var label = track.getAttribute('data-track-label');
      if (label) trackByLabel[label.toUpperCase()] = track;
    });

    var assignedTracks = {};
    var assignedSources = {};

    sources.forEach(function (source) {
      if (source.label && trackByLabel[source.label]) {
        var track = trackByLabel[source.label];

        if (!assignedTracks[source.label]) {
          track.setAttribute('data-youtube', 'https://www.youtube.com/watch?v=' + source.id);
          track.setAttribute('data-eb-source', 'auto');
          assignedTracks[source.label] = true;
          assignedSources[source.id] = true;

          if (source.element.tagName === 'IFRAME') {
            hideOriginalEmbed(source.element);
          }
        }
      }
    });

    var labels = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];

    sources.forEach(function (source) {
      if (assignedSources[source.id]) return;

      var target = null;

      for (var i = 0; i < labels.length; i++) {
        var label = labels[i];
        if (trackByLabel[label] && !assignedTracks[label]) {
          target = trackByLabel[label];
          assignedTracks[label] = true;
          break;
        }
      }

      if (!target) return;

      target.setAttribute('data-youtube', 'https://www.youtube.com/watch?v=' + source.id);
      target.setAttribute('data-eb-source', 'auto');

      if (source.element.tagName === 'IFRAME') {
        hideOriginalEmbed(source.element);
      }
    });

    /* Hide SoundCloud and YouTube iframes only after their URLs have been read. */
    description.querySelectorAll('iframe').forEach(function (iframe) {
      var url = getMediaUrl(iframe);

      if (
        getYouTubeId(url) ||
        /soundcloud\.com/i.test(url)
      ) {
        hideOriginalEmbed(iframe);
      }
    });

    return tracks.filter(function (track) {
      return !!getYouTubeId(track.getAttribute('data-youtube'));
    });
  }

  function formatTime(seconds) {
    seconds = Math.floor(Number(seconds) || 0);

    var minutes = Math.floor(seconds / 60);
    var secs = seconds % 60;

    return (
      String(minutes).padStart(2, '0') +
      ':' +
      String(secs).padStart(2, '0')
    );
  }

  function pauseOtherPlayers(currentTrack) {
    document.querySelectorAll('[data-track]').forEach(function (other) {
      if (other === currentTrack) return;

      var otherPlayer = other._ebPlayer;

      if (otherPlayer) {
        try {
          otherPlayer.pauseVideo();
        } catch (e) {}
      }

      other.classList.remove('is-playing');
    });
  }

  function setupTrack(track) {
    var videoId = getYouTubeId(track.getAttribute('data-youtube'));
    if (!videoId) return;

    if (track.dataset.ebPlayerReady === 'true') return;
    track.dataset.ebPlayerReady = 'true';

    var youtubeElement = track.querySelector('.eb-mini-youtube-inner');
    var button = track.querySelector('.eb-mini-play');
    var progress = track.querySelector('[data-progress]');
    var fill = track.querySelector('[data-progress-fill]');
    var hoverDot = track.querySelector('[data-hover-dot]');
    var hoverTime = track.querySelector('[data-hover-time]');
    var time = track.querySelector('[data-time]');

    if (!youtubeElement || !button || !progress || !fill || !time) return;

    var player = null;
    var animationFrame = null;

    function updateProgress() {
      if (!player) return;

      try {
        var current = player.getCurrentTime();
        var total = player.getDuration();

        if (total > 0) {
          var percentage = Math.max(0, Math.min(100, (current / total) * 100));

          fill.style.width = percentage + '%';
          time.textContent =
            formatTime(current) + ' / ' + formatTime(total);
        }

        if (
          player.getPlayerState &&
          player.getPlayerState() === YT.PlayerState.PLAYING
        ) {
          animationFrame = requestAnimationFrame(updateProgress);
        }
      } catch (e) {}
    }

    player = new YT.Player(youtubeElement, {
      videoId: videoId,
      playerVars: {
        autoplay: 0,
        controls: 0,
        disablekb: 1,
        fs: 0,
        modestbranding: 1,
        rel: 0,
        playsinline: 1
      },
      events: {
        onReady: function (event) {
          var total = event.target.getDuration();

          time.textContent = '00:00 / ' + formatTime(total);
        },

        onStateChange: function (event) {
          if (event.data === YT.PlayerState.PLAYING) {
            pauseOtherPlayers(track);
            track.classList.add('is-playing');
            updateProgress();
          }

          if (event.data === YT.PlayerState.PAUSED) {
            track.classList.remove('is-playing');
            if (animationFrame) cancelAnimationFrame(animationFrame);
          }

          if (event.data === YT.PlayerState.ENDED) {
            track.classList.remove('is-playing');
            fill.style.width = '0%';
            time.textContent =
              '00:00 / ' + formatTime(event.target.getDuration());

            if (animationFrame) cancelAnimationFrame(animationFrame);
          }
        }
      }
    });

    track._ebPlayer = player;

    button.addEventListener('click', function () {
      if (!player) return;

      try {
        var state = player.getPlayerState();

        if (state === YT.PlayerState.PLAYING) {
          player.pauseVideo();
        } else {
          pauseOtherPlayers(track);
          player.playVideo();
        }
      } catch (e) {}
    });

    progress.addEventListener('mousemove', function (event) {
      if (!player) return;

      var total = player.getDuration();
      if (!total || total <= 0) return;

      var rect = progress.getBoundingClientRect();

      var percentage =
        (event.clientX - rect.left) / rect.width;

      percentage = Math.max(0, Math.min(1, percentage));

      var position = percentage * 100;

      if (hoverDot) hoverDot.style.left = position + '%';
      if (hoverTime) {
        hoverTime.style.left = position + '%';
        hoverTime.textContent = formatTime(total * percentage);
      }
    });

    progress.addEventListener('click', function (event) {
      if (!player) return;

      var rect = progress.getBoundingClientRect();

      var percentage =
        (event.clientX - rect.left) / rect.width;

      percentage = Math.max(0, Math.min(1, percentage));

      var total = player.getDuration();

      if (total > 0) {
        player.seekTo(total * percentage, true);
        updateProgress();
      }
    });
  }


  /* ExperimentalBass: YouTube previews on collection/product cards. */
  var ebCardPlayers = [];
  var ebBottomPlayer = null;
  var ebYouTubeLoading = false;
  var ebYouTubeCallbacks = [];

  function whenYouTubeReady(callback) {
    if (window.YT && window.YT.Player) { callback(); return; }
    ebYouTubeCallbacks.push(callback);
    if (ebYouTubeLoading) return;
    ebYouTubeLoading = true;
    var oldCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof oldCallback === 'function') { try { oldCallback(); } catch (e) {} }
      ebYouTubeLoading = false;
      var callbacks = ebYouTubeCallbacks.slice();
      ebYouTubeCallbacks.length = 0;
      callbacks.forEach(function (cb) { try { cb(); } catch (e) {} });
    };
    var script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true;
    document.head.appendChild(script);
  }

  window.EBOpenBottomPlayer = function(config) {
    if (!window.YT || !window.YT.Player) return;
    return ensureBottomPlayer().open(config || {});
  };

  function ensureBottomPlayer() {
    if (ebBottomPlayer) return ebBottomPlayer;

    var root = document.createElement('div');
    root.id = 'eb-bottom-player';
    root.className = 'eb-bottom-player';
    root.setAttribute('aria-label', 'Audio preview player');
    /* Put the player in the browser top layer when opened, above theme overlays and iframes. */
    if (typeof root.showPopover === 'function') root.setAttribute('popover', 'manual');
    root.innerHTML = `
      <div class="eb-bottom-art-wrap">
        <img class="eb-bottom-art" alt="">
      </div>
      <div class="eb-bottom-info">
        <div class="eb-bottom-title"></div>
        <div class="eb-bottom-track-name"></div>
      </div>
      <button type="button" class="eb-bottom-main-play" aria-label="Play" aria-pressed="false">
        <span class="eb-bottom-play-icon"></span>
      </button>
      <div class="eb-bottom-track-list" role="list"></div>
      <div class="eb-bottom-progress-wrap">
        <div class="eb-bottom-progress" role="slider" tabindex="0" aria-label="Seek preview" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
          <div class="eb-bottom-progress-fill"></div>
          <div class="eb-bottom-progress-hover-dot" aria-hidden="true"></div>
          <div class="eb-bottom-progress-hover-time" aria-hidden="true"></div>
        </div>
      </div>
      <div class="eb-bottom-time">0:00 / 0:00</div>
      <button type="button" class="eb-bottom-cart" aria-label="Add current record to cart" title="Add to cart" onclick="return window.ExperimentalBassAddCurrentToCart(event);">
        <svg class="eb-bottom-cart-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M3 4h2l2.1 10.1a2 2 0 0 0 2 1.6h8.8a2 2 0 0 0 1.9-1.4L22 7H7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="10" cy="20" r="1.3" fill="currentColor"/>
          <circle cx="18" cy="20" r="1.3" fill="currentColor"/>
        </svg>
        <span class="eb-bottom-cart-count" aria-live="polite" aria-label="Items in cart"></span>
      </button>
      <button type="button" class="eb-bottom-close" aria-label="Close player">×</button>
      <div class="eb-bottom-youtube" aria-hidden="true"></div>
    `;
    /* Keep normal player controls working, but block accidental fall-through
       if another theme layer receives an event at coordinates covered by this bar. */
    /* The bottom player itself must be the hit target. This is important
       because events inside an iframe behind it cannot be cancelled by the
       parent window's event listeners. Keep controls working, but never let
       a player-bar interaction bubble into product-card handlers. */
    root.style.setProperty('pointer-events', 'auto', 'important');
    ['click', 'pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function(type) {
      root.addEventListener(type, function(event) {
        event.stopPropagation();
      }, false);
    });

    if (!window.__ebBottomPlayerGuardInstalled) {
      window.__ebBottomPlayerGuardInstalled = true;
      var ebGuardCoveredCoordinates = function(event) {
        var bar = document.getElementById('eb-bottom-player');
        if (!bar || !bar.classList.contains('is-visible')) return;
        var x = event.clientX;
        var y = event.clientY;
        var rect = bar.getBoundingClientRect();
        var inside = x >= rect.left && x <= rect.right &&
                     y >= rect.top && y <= rect.bottom;
        if (!inside) return;

        /* Let all real player controls work. Cancel only events that pass
           through the bar and target an element behind it. */
        var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
        var targetIsInsidePlayer = bar.contains(event.target) || path.indexOf(bar) !== -1;
        if (targetIsInsidePlayer) return;

        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      };
      /* Capture every common input path. Some themes start card previews on
         mousedown/touchstart rather than click, so guarding only pointerdown
         can still allow the card behind the fixed player to activate. */
      window.addEventListener('pointerdown', ebGuardCoveredCoordinates, true);
      window.addEventListener('mousedown', ebGuardCoveredCoordinates, true);
      window.addEventListener('touchstart', function(event) {
        var touch = event.touches && event.touches[0];
        if (!touch) return;
        var wrapped = {
          clientX: touch.clientX,
          clientY: touch.clientY,
          preventDefault: function() { if (event.cancelable) event.preventDefault(); },
          stopPropagation: function() { event.stopPropagation(); },
          stopImmediatePropagation: function() { event.stopImmediatePropagation(); }
        };
        ebGuardCoveredCoordinates(wrapped);
      }, { capture: true, passive: false });
      window.addEventListener('click', ebGuardCoveredCoordinates, true);
    }

    document.body.appendChild(root);

    var style = document.createElement('style');
        style.id = 'eb-bottom-player-styles';
    style.textContent = `
      #eb-bottom-player{position:fixed!important;inset:auto 0 0 0!important;top:auto!important;left:0!important;right:0!important;bottom:0!important;margin:0!important;transform:none!important;width:100vw!important;max-width:none!important;z-index:2147483647;height:56px;min-height:56px;pointer-events:auto!important;background:#000;border:0;padding-top:8px;color:#fff;display:none;align-items:center;gap:12px;padding:8px 18px 8px 10px;box-sizing:border-box;font-family:inherit;box-shadow:0 -3px 18px rgba(0,0,0,.22)}
      #eb-bottom-player.is-visible{display:flex!important;pointer-events:auto!important;visibility:visible!important}
      #eb-bottom-player .eb-bottom-art-wrap{width:42px;height:42px;flex:0 0 42px;overflow:hidden;background:#111}
      #eb-bottom-player .eb-bottom-art{width:100%;height:100%;object-fit:cover;display:block}
      #eb-bottom-player .eb-bottom-info{width:180px;min-width:110px;overflow:hidden}
      #eb-bottom-player .eb-bottom-title{font-size:14px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      #eb-bottom-player .eb-bottom-track-name{font-size:12px;opacity:.68;margin-top:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      #eb-bottom-player .eb-bottom-main-play{width:34px;height:34px;border:1px solid rgba(255,255,255,.8);border-radius:50%;background:transparent;color:#fff;display:flex;align-items:center;justify-content:center;flex:0 0 34px;cursor:pointer;padding:0}
      #eb-bottom-player .eb-bottom-main-play:hover{background:rgba(255,255,255,.08)}
      #eb-bottom-player .eb-bottom-play-icon{width:0;height:0;border-top:8px solid transparent;border-bottom:8px solid transparent;border-left:12px solid #fff;margin-left:3px}
      #eb-bottom-player.is-playing .eb-bottom-play-icon{width:12px;height:16px;border:0;margin:0;position:relative}
      #eb-bottom-player.is-playing .eb-bottom-play-icon:before,#eb-bottom-player.is-playing .eb-bottom-play-icon:after{content:"";position:absolute;top:0;bottom:0;width:4px;background:#fff}
      #eb-bottom-player.is-playing .eb-bottom-play-icon:before{left:0}.eb-bottom-player.is-playing .eb-bottom-play-icon:after{right:0}
      #eb-bottom-player .eb-bottom-track-list{display:flex;align-items:center;gap:6px;min-width:0;max-width:360px;overflow-x:auto;scrollbar-width:none}
      #eb-bottom-player .eb-bottom-track-list::-webkit-scrollbar{display:none}
      #eb-bottom-player .eb-bottom-track{height:32px;min-width:34px;padding:0 9px;border-radius:18px;border:1px solid rgba(255,255,255,.18);background:transparent;color:#fff;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap}
      #eb-bottom-player .eb-bottom-track:hover{border-color:rgba(255,255,255,.55)}
      #eb-bottom-player .eb-bottom-track.is-active{background:#e30613;color:#fff;border-color:#e30613}
      #eb-bottom-player .eb-bottom-progress-wrap{flex:1;min-width:80px}
      #eb-bottom-player .eb-bottom-progress{height:28px;display:flex;align-items:center;cursor:pointer;position:relative}
      #eb-bottom-player .eb-bottom-progress:before{content:"";position:absolute;left:0;right:0;top:50%;transform:translateY(-50%);height:5px;background:#3b3b3b;border-radius:5px;z-index:1}
      #eb-bottom-player .eb-bottom-progress-fill{position:absolute;left:0;top:50%;transform:translateY(-50%);height:6px;width:0;background:#fff!important;border-radius:6px;z-index:3;display:block;min-width:0}
      #eb-bottom-player .eb-bottom-progress-hover-dot{position:absolute;top:50%;left:0;width:10px;height:10px;border-radius:50%;background:#fff;transform:translate(-50%,-50%);opacity:0;pointer-events:none;box-shadow:0 0 0 2px rgba(0,0,0,.7);z-index:4}
      #eb-bottom-player .eb-bottom-progress-hover-time{position:absolute;left:0;bottom:28px;transform:translateX(-50%);padding:4px 6px;background:#fff;color:#000;font-size:10px;line-height:1;border-radius:3px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity .12s ease;z-index:5}
      #eb-bottom-player .eb-bottom-progress:hover .eb-bottom-progress-hover-dot,#eb-bottom-player .eb-bottom-progress:hover .eb-bottom-progress-hover-time{opacity:1}
      #eb-bottom-player .eb-bottom-time{font-size:11px;white-space:nowrap;opacity:.8;min-width:72px;text-align:right}
      #eb-bottom-player .eb-bottom-cart{width:38px;height:38px;border:0;background:transparent;color:#fff;display:flex;align-items:center;justify-content:center;flex:0 0 34px;cursor:pointer;padding:0;opacity:.78}
      #eb-bottom-player .eb-bottom-cart:hover{opacity:1}
      #eb-bottom-player .eb-bottom-cart.is-added{color:#fff}
      #eb-bottom-player .eb-bottom-cart-icon{width:22px;height:22px;display:block}
      #eb-bottom-player .eb-bottom-cart{position:relative}
      #eb-bottom-player .eb-bottom-cart-count{position:absolute;top:0;right:-2px;min-width:16px;height:16px;padding:0 4px;border-radius:999px;background:#e30613;color:#fff;font-size:10px;font-weight:800;line-height:16px;text-align:center;box-sizing:border-box;display:none}
      #eb-bottom-player .eb-bottom-cart-count.is-visible{display:block}
      #eb-bottom-player .eb-bottom-close{width:34px;height:34px;border:0;background:transparent;color:#fff;font-size:28px;line-height:1;cursor:pointer;opacity:.65;padding:0}
      #eb-bottom-player .eb-bottom-close:hover{opacity:1}
      #eb-bottom-player .eb-bottom-youtube{position:absolute;width:1px;height:1px;left:-9999px;top:-9999px;overflow:hidden}
      @media(max-width:900px){#eb-bottom-player{height:54px;padding:7px 10px;gap:8px}.eb-bottom-info{width:150px!important}.eb-bottom-track-list{max-width:260px!important}}
      @media(max-width:640px){#eb-bottom-player{height:auto!important;min-height:68px;flex-wrap:wrap;padding:6px 8px calc(8px + env(safe-area-inset-bottom));gap:8px;row-gap:4px}#eb-bottom-player .eb-bottom-art-wrap{width:44px!important;height:44px!important;flex:0 0 44px!important}#eb-bottom-player .eb-bottom-info{flex:1 1 0;width:auto!important;min-width:0}#eb-bottom-player .eb-bottom-main-play{width:40px!important;height:40px!important;flex:0 0 40px!important}#eb-bottom-player .eb-bottom-time{min-width:0;font-size:10px}#eb-bottom-player .eb-bottom-cart{flex:0 0 32px;width:32px}#eb-bottom-player .eb-bottom-close{flex:0 0 28px;width:28px}#eb-bottom-player .eb-bottom-progress-wrap{display:block!important;order:4;flex:0 0 100%;width:100%;min-width:0}#eb-bottom-player .eb-bottom-progress{height:22px;touch-action:none}#eb-bottom-player .eb-bottom-track-list{order:5;flex:0 0 100%;width:100%;max-width:none!important;height:auto}#eb-bottom-player .eb-bottom-track{height:30px!important;min-width:38px!important;padding:0 10px!important}}
    `;
    document.head.appendChild(style);

    var player = {
      root: root,
      art: root.querySelector('.eb-bottom-art'),
      title: root.querySelector('.eb-bottom-title'),
      trackName: root.querySelector('.eb-bottom-track-name'),
      mainPlay: root.querySelector('.eb-bottom-main-play'),
      trackList: root.querySelector('.eb-bottom-track-list'),
      progress: root.querySelector('.eb-bottom-progress'),
      fill: root.querySelector('.eb-bottom-progress-fill'),
      hoverDot: root.querySelector('.eb-bottom-progress-hover-dot'),
      hoverTime: root.querySelector('.eb-bottom-progress-hover-time'),
      time: root.querySelector('.eb-bottom-time'),
      cart: root.querySelector('.eb-bottom-cart'),
      cartCount: root.querySelector('.eb-bottom-cart-count'),
      close: root.querySelector('.eb-bottom-close'),
      youtube: root.querySelector('.eb-bottom-youtube'),
      tracks: [],
      activeIndex: 0,
      yt: null,
      raf: null,
      progressTimer: null,
      currentProductId: null,
      currentVariantId: null,
      currentProductUrl: ''
    };

    function formatShort(seconds) {
      seconds = Math.max(0, Math.floor(Number(seconds) || 0));
      return Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
    }

    function setPlaying(playing) {
  root.classList.toggle('is-playing', !!playing);
  player.mainPlay.setAttribute(
    'aria-pressed', playing ? 'true' : 'false'
  );

  document.querySelectorAll('[data-eb-card-audio]').forEach(function(card) {
    var active =
      String(card.getAttribute('data-product-id')) ===
      String(player.currentProductId);

    var isPlaying = active && !!playing;
    card.classList.toggle('is-playing', isPlaying);

    var button = card.querySelector('[data-eb-card-play]');
    if (button) {
      button.setAttribute('aria-pressed', String(isPlaying));
      button.setAttribute(
        'aria-label', isPlaying ? 'Pause preview' : 'Play preview'
      );
    }
  });
}

    function updateProgress() {
      if (!player.yt) return;
      try {
        var current = (typeof player.yt.getCurrentTime === 'function') ? (player.yt.getCurrentTime() || 0) : 0;
        var total = (typeof player.yt.getDuration === 'function') ? (player.yt.getDuration() || 0) : 0;
        var pct = total ? Math.max(0, Math.min(100, current / total * 100)) : 0;
        player.fill.style.width = pct + '%';
        player.progress.setAttribute('aria-valuenow', String(Math.round(pct)));
        player.time.textContent = formatShort(current) + ' / ' + formatShort(total);
        if (player.yt.getPlayerState() === YT.PlayerState.PLAYING) {
          player.raf = requestAnimationFrame(updateProgress);
          if (!player.progressTimer) player.progressTimer = setInterval(updateProgress, 250);
        }
      } catch(e) {}
    }

    function renderTracks() {
      player.trackList.innerHTML = '';
      player.tracks.forEach(function(track, index) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'eb-bottom-track' + (index === player.activeIndex ? ' is-active' : '');
        btn.textContent = track.label || ('Track ' + (index + 1));
        btn.title = track.title || btn.textContent;
        btn.setAttribute('aria-label', 'Play ' + (track.title || btn.textContent));
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          playTrack(index);
        });
        player.trackList.appendChild(btn);
      });
    }

    function updateActiveButtons() {
      Array.prototype.forEach.call(player.trackList.children, function(btn, i) {
        btn.classList.toggle('is-active', i === player.activeIndex);
      });
      var active = player.tracks[player.activeIndex];
      player.trackName.textContent = active ? ((active.label ? active.label + ' — ' : '') + (active.title || '')) : '';
    }

    function playTrack(index) {
      if (!player.tracks[index] || !player.yt) return;
      player.activeIndex = index;
      updateActiveButtons();
      try {
        player.yt.loadVideoById(player.tracks[index].id);
        player.yt.playVideo();
      } catch(e) {}
    }

    player.mainPlay.addEventListener('click', function(e) {
      e.preventDefault();
      if (!player.yt || !player.tracks.length) return;
      try {
        if (player.yt.getPlayerState() === YT.PlayerState.PLAYING) player.yt.pauseVideo();
        else player.yt.playVideo();
      } catch(e) {}
    });

    player.progress.addEventListener('mousemove', function(e) {
      if (!player.yt) return;
      var total = (typeof player.yt.getDuration === 'function') ? (player.yt.getDuration() || 0) : 0;
      if (!total || total <= 0) return;
      var rect = player.progress.getBoundingClientRect();
      var pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      var left = (pct * 100) + '%';
      if (player.hoverDot) player.hoverDot.style.left = left;
      if (player.hoverTime) {
        player.hoverTime.style.left = left;
        player.hoverTime.textContent = formatShort(total * pct);
      }
    });

    player.progress.addEventListener('click', function(e) {
      if (!player.yt) return;
      var rect = player.progress.getBoundingClientRect();
      var pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      try {
        var duration = (typeof player.yt.getDuration === 'function') ? (player.yt.getDuration() || 0) : 0;
        if (duration > 0 && typeof player.yt.seekTo === 'function') player.yt.seekTo(duration * pct, true);
        updateProgress();
      } catch(err) {}
    });

    function updateCartCount(count) {
      var value = Number(count);
      if (!isFinite(value) || value < 0) value = 0;
      value = Math.floor(value);
      if (player.cartCount) {
        player.cartCount.textContent = value > 0 ? String(value) : '';
        player.cartCount.classList.toggle('is-visible', value > 0);
      }
      document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count').forEach(function(el) {
        el.textContent = value > 0 ? String(value) : '';
        el.classList.toggle('hidden', value === 0);
      });
    }

    function refreshCartCount() {
      return fetch('/cart.js', {credentials:'same-origin', headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(cart){ updateCartCount(cart && cart.item_count || 0); return cart; })
        .catch(function(){ return null; });
    }

    function addCurrentRecordToCart(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }

      var variantId = String(player.currentVariantId || '').trim();
      if (!variantId || !/^\d+$/.test(variantId)) {
        player.cart.setAttribute('aria-label', 'Product unavailable');
        return false;
      }

      if (player.cart.dataset.adding === 'true') return false;
      player.cart.dataset.adding = 'true';
      player.cart.disabled = true;
      player.cart.classList.remove('is-added');

      var cartUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      fetch(cartUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok || data.status || data.errors) {
            throw new Error(data.description || data.message || 'Cart add failed');
          }
          return data;
        });
      })
      .then(function(data) {
        player.cart.classList.add('is-added');
        player.cart.setAttribute('aria-label', 'Added to cart');
        player.cart.dataset.adding = 'false';
        player.cart.disabled = false;

        /* Use Dawn's own cart update system. This refreshes the cart drawer
           without navigating away from the page or stopping the player. */
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'experimentalbass-player',
              productVariantId: variantId,
              cartData: data
            });
          }
        } catch (pubError) {
          console.warn('ExperimentalBass cart update event:', pubError);
        }

        refreshCartCount();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          setTimeout(function() {
            try { drawer.open(player.cart); } catch (openError) {}
          }, 150);
        }
      })
      .catch(function(error) {
        console.warn('ExperimentalBass cart add:', error);
        player.cart.dataset.adding = 'false';
        player.cart.disabled = false;
        player.cart.classList.remove('is-added');
        player.cart.setAttribute('aria-label', 'Could not add to cart');
      });

      return false;
    }

    window.ExperimentalBassAddCurrentToCart = addCurrentRecordToCart;
    player.cart.addEventListener('click', addCurrentRecordToCart);
    refreshCartCount();

    player.close.addEventListener('click', function() {
      try { if (player.yt) player.yt.stopVideo(); } catch(e) {}
      try { if (root.matches && root.matches(':popover-open')) root.hidePopover(); } catch (popoverError) {}
      root.classList.remove('is-visible');
      setPlaying(false);
      if (player.raf) cancelAnimationFrame(player.raf); if (player.progressTimer) { clearInterval(player.progressTimer); player.progressTimer = null; }
    });

    player.open = function(config) {
      player.currentProductId = config.productId;
      player.currentVariantId = config.variantId || '';
      player.currentProductUrl = config.productUrl || '';
      player.cart.classList.remove('is-added');
      player.cart.disabled = false;
            player.tracks = (config.tracks || []).map(function (track) {
        var copy = Object.assign({}, track);
        copy.id = copy.mp3 || copy.id;
        return copy;
      });
      player.activeIndex = Math.max(0, config.startIndex || 0);
      player.title.textContent = config.title || '';
      player.art.src = config.image || '';
      player.art.alt = config.title || '';
      renderTracks();
      updateActiveButtons();
      root.classList.add('is-visible');
      try { if (typeof root.showPopover === 'function' && !root.matches(':popover-open')) root.showPopover(); } catch (popoverError) { console.warn('ExperimentalBass player top layer:', popoverError); }
      setPlaying(false);
      // Pause the previous playback source before switching.
      if (player.yt) {
        try { player.yt.pauseVideo(); } catch (e) {}
      }

      if (player.yt && player.yt !== player.mp3Adapter && player.yt !== player.scAdapter) {
        player.savedYouTubePlayer = player.yt;
      }
      if (player.yt === player.scAdapter) player.yt = player.savedYouTubePlayer || null;

      if (player.tracks.length && player.tracks.every(function(t) { return !!t.soundcloud; })) {
        if (!player.scAdapter) {
          var scState = 2, scTime = 0, scDuration = 0;
          var scWidget = null, scReady = false, scPending = null;
          var scFrame = document.createElement('iframe');
          scFrame.title = 'SoundCloud audio preview';
          scFrame.allow = 'autoplay';
          scFrame.style.cssText = 'position:absolute;width:1px;height:1px;left:-9999px;border:0';
          scFrame.src = 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(player.tracks[player.activeIndex].soundcloud) + '&auto_play=false';
          root.appendChild(scFrame);
          function scLoadPending() {
            if (!scReady || !scPending) return;
            var url = scPending;
            scPending = null;
            scWidget.load(url, {auto_play:true, callback:function() {
              scWidget.getDuration(function(ms) { scDuration = ms / 1000; });
              scWidget.play();
            }});
          }
          player.scAdapter = {
            loadVideoById:function(url) { scTime = 0; scDuration = 0; scPending = url; scLoadPending(); },
            playVideo:function() { if (scReady) scWidget.play(); },
            pauseVideo:function() { if (scReady) scWidget.pause(); },
            stopVideo:function() { if (scReady) { scWidget.pause(); scWidget.seekTo(0); } },
            getCurrentTime:function() { return scTime; },
            getDuration:function() { return scDuration; },
            getPlayerState:function() { return scState; },
            seekTo:function(seconds) { if (scReady) scWidget.seekTo(seconds * 1000); }
          };
          function connectSoundCloud() {
            if (!window.SC || !window.SC.Widget) return;
            scWidget = SC.Widget(scFrame);
            scWidget.bind(SC.Widget.Events.READY, function() { scReady = true; scLoadPending(); });
            scWidget.bind(SC.Widget.Events.PLAY, function() {
              scState = 1;
              if (player.yt !== player.scAdapter) { scWidget.pause(); return; }
              setPlaying(true);
              scWidget.getDuration(function(ms) { scDuration = ms / 1000; });
              updateProgress();
            });
            scWidget.bind(SC.Widget.Events.PAUSE, function() {
              scState = 2;
              if (player.yt === player.scAdapter) setPlaying(false);
            });
            scWidget.bind(SC.Widget.Events.PLAY_PROGRESS, function(e) { scTime = e.currentPosition / 1000; });
            scWidget.bind(SC.Widget.Events.FINISH, function() {
              scState = 0;
              if (player.yt !== player.scAdapter) return;
              setPlaying(false);
              if (player.activeIndex < player.tracks.length - 1) playTrack(player.activeIndex + 1);
            });
            scWidget.bind(SC.Widget.Events.ERROR, function() {
              if (player.yt !== player.scAdapter) return;
              setPlaying(false);
              player.trackName.textContent = 'SoundCloud preview unavailable. Please try again.';
            });
          }
          if (window.SC && window.SC.Widget) connectSoundCloud();
          else {
            var scScript = document.createElement('script');
            scScript.src = 'https://w.soundcloud.com/player/api.js';
            scScript.onload = connectSoundCloud;
            scScript.onerror = function() { player.trackName.textContent = 'Unable to load SoundCloud.'; };
            document.head.appendChild(scScript);
          }
        }
        player.yt = player.scAdapter;
        playTrack(player.activeIndex);
        return;
      }

      var mp3Only = player.tracks.length > 0 &&
        player.tracks.every(function (track) {
          return /^https:\/\/.+\.mp3(?:[?#]|$)/i.test(track.id || '');
        });

      if (mp3Only) {
        if (!player.mp3Adapter) {
          var audio = new Audio();
          audio.preload = 'metadata';

          player.mp3Adapter = {
            loadVideoById: function (url) {
              audio.src = url;
              audio.load();
            },
            playVideo: function () {
              var promise = audio.play();

              if (promise && promise.catch) {
                promise.catch(function () {
                  setPlaying(false);
                  player.trackName.textContent =
                    'Press play to listen. If playback fails, check the MP3 link.';
                });
              }
            },
            pauseVideo: function () {
              audio.pause();
            },
            stopVideo: function () {
              audio.pause();
              try { audio.currentTime = 0; } catch (e) {}
            },
            getCurrentTime: function () {
              return audio.currentTime || 0;
            },
            getDuration: function () {
              return isFinite(audio.duration) ? audio.duration : 0;
            },
            getPlayerState: function () {
              return audio.paused ? 2 : 1;
            },
            seekTo: function (seconds) {
              if (isFinite(audio.duration)) {
                audio.currentTime = Math.max(
                  0,
                  Math.min(seconds, audio.duration)
                );
              }
            }
          };

          audio.addEventListener('play', function () {
            setPlaying(true);
            updateProgress();
          });

          audio.addEventListener('pause', function () {
            setPlaying(false);
            if (player.raf) cancelAnimationFrame(player.raf);
            if (player.progressTimer) {
              clearInterval(player.progressTimer);
              player.progressTimer = null;
            }
          });

          audio.addEventListener('loadedmetadata', updateProgress);
          audio.addEventListener('timeupdate', updateProgress);

          audio.addEventListener('ended', function () {
            if (player.activeIndex < player.tracks.length - 1) {
              playTrack(player.activeIndex + 1);
            } else {
              setPlaying(false);
            }
          });

          audio.addEventListener('error', function () {
            setPlaying(false);
            player.trackName.textContent =
              'Audio unavailable. Please try again.';
          });
        }

        if (player.yt && player.yt !== player.mp3Adapter) {
          player.savedYouTubePlayer = player.yt;
        }

        player.yt = player.mp3Adapter;
      } else if (player.yt === player.mp3Adapter) {
        player.yt = player.savedYouTubePlayer || null;
      }
      if (!player.yt) {
        player.yt = new YT.Player(player.youtube, {
          width: '1', height: '1',
          playerVars: {autoplay:0,controls:0,disablekb:1,fs:0,modestbranding:1,rel:0,playsinline:1},
          events: {
            onReady: function() { playTrack(player.activeIndex); },
            onStateChange: function(event) {
              if (event.data === YT.PlayerState.PLAYING) { setPlaying(true); updateProgress(); }
              else if (event.data === YT.PlayerState.PAUSED) { setPlaying(false); if (player.raf) cancelAnimationFrame(player.raf); if (player.progressTimer) { clearInterval(player.progressTimer); player.progressTimer = null; } }
              else if (event.data === YT.PlayerState.ENDED) {
                setPlaying(false); if (player.raf) cancelAnimationFrame(player.raf); if (player.progressTimer) { clearInterval(player.progressTimer); player.progressTimer = null; }
                if (player.activeIndex < player.tracks.length - 1) playTrack(player.activeIndex + 1);
              }
            }
          }
        });
      } else {
        playTrack(player.activeIndex);
      }
    };

    ebBottomPlayer = player;
    return player;
  }

  function getCardTracks(source) {
    if (!source) return [];
    if (source.tagName === 'TEMPLATE') {
      var parsedSource = document.createElement('div');
      parsedSource.appendChild(source.content.cloneNode(true));
      source = parsedSource;
    }
    var soundcloudTracks = [];
    var seenSoundCloud = {};
    source.querySelectorAll('iframe').forEach(function(frame) {
      try {
        var embed = new URL(frame.getAttribute('src') || frame.getAttribute('data-src') || frame.getAttribute('data-eb-original-src') || '', location.href);
        if (embed.hostname !== 'w.soundcloud.com') return;
        var trackUrl = embed.searchParams.get('url');
        if (!trackUrl || seenSoundCloud[trackUrl]) return;
        var checked = new URL(trackUrl);
        if (!/(^|\.)soundcloud\.com$/.test(checked.hostname)) return;
        seenSoundCloud[trackUrl] = true;
        soundcloudTracks.push({id:trackUrl, soundcloud:trackUrl, label: 'Track ' + (soundcloudTracks.length + 1), title:frame.getAttribute('title') || ''});
      } catch (error) {}
    });
    // Read explicitly labelled MP3 previews from the description.
    var mp3Source = source.tagName === 'TEMPLATE'
      ? source.content
      : source;

    var mp3Links = mp3Source.querySelectorAll(
      'a[data-eb-mp3][href]'
    );

    var mp3Tracks = [];

    mp3Links.forEach(function (link) {
      var url = link.getAttribute('href') || '';

      if (!/^https:\/\/.+\.mp3(?:[?#]|$)/i.test(url)) return;

      mp3Tracks.push({
        id: url,
        mp3: url,
        label: link.getAttribute('data-eb-label') ||
          ('Track ' + (mp3Tracks.length + 1)),
        title: link.getAttribute('data-eb-title') ||
          link.textContent.trim()
      });
    });

    if (mp3Tracks.length) return mp3Tracks;
    if (soundcloudTracks.length) return soundcloudTracks;
    var tracks = [];
    var used = {};
    var usedLabels = {};
    var fallbackLabels = ['A1','A2','A3','A4','B1','B2','B3','B4'];

    function addTrack(url, element) {
      var id = getYouTubeId(url);
      if (!id || used[id]) return;
      used[id] = true;

      var found = element ? findNearbyLabel(element) : null;
      var label = found && !usedLabels[found] ? found : null;
      if (!label) {
        for (var j = 0; j < fallbackLabels.length; j++) {
          if (!usedLabels[fallbackLabels[j]]) {
            label = fallbackLabels[j];
            break;
          }
        }
      }

      label = label || ('Track ' + (tracks.length + 1));
      usedLabels[label] = true;
      var title = element && element.getAttribute ? (element.getAttribute('title') || '') : '';
      tracks.push({id:id, label:label, title:title});
    }

    /* First read normal iframe/link/embed elements. */
    var elements = source.querySelectorAll('iframe, a[href], [src], [data-src], [data-lazy-src]');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var url = el.getAttribute('src') || el.getAttribute('data-src') || el.getAttribute('data-lazy-src') || el.getAttribute('href') || '';
      addTrack(url, el);
    }

    /*
     * Some Shopify descriptions contain the YouTube URL as plain text or
     * inside HTML that is not represented by an iframe/link in the card.
     * In that case the old card player found zero tracks, so the click was
     * allowed to fall through to the product link. Parse the complete HTML
     * as a fallback.
     */
    var html = source.innerHTML || '';
    var text = source.textContent || '';
    var combined = html + '\n' + text;
    var urlRegex = /https?:\/\/(?:www\.)?(?:youtube\.com\/(?:watch\?v=[^\s&<>"']+|embed\/[^\s?&<>"']+|shorts\/[^\s?&<>"']+)|youtu\.be\/[^\s?&<>"']+)/gi;
    var match;
    while ((match = urlRegex.exec(combined)) !== null) {
      addTrack(match[0], null);
    }

    /* Final fallback for raw YouTube IDs in embed attributes. */
    if (!tracks.length) {
      var idRegex = /(?:youtube\.com\/embed\/|youtu\.be\/)([A-Za-z0-9_-]{6,})/gi;
      while ((match = idRegex.exec(combined)) !== null) {
        addTrack('https://www.youtube.com/watch?v=' + match[1], null);
      }
    }

    return tracks;
  }

  function pauseOtherCardPlayers(current) {
    ebCardPlayers.forEach(function(item) {
      if (item === current) return;
      if (item.player) { try { item.player.pauseVideo(); } catch (e) {} }
      if (item.container) item.container.classList.remove('is-playing');
      if (item.button) item.button.setAttribute('aria-pressed', 'false');
    });
  }

  function getCardElementFromButton(button) {
    if (!button) return null;
    var card = button.closest ? button.closest('[data-eb-card-audio]') : null;
    if (card) return card;
    var node = button.parentElement;
    while (node && node !== document.body) {
      if (node.hasAttribute && node.hasAttribute('data-eb-card-audio')) return node;
      node = node.parentElement;
    }
    return null;
  }

  function getCardOpenConfig(button) {
    var card = getCardElementFromButton(button);
    if (!card) return null;
    var source = card.querySelector('[data-eb-card-description]');
    var tracks = getCardTracks(source);
    if (!tracks.length) return null;
    return {
      productId: card.getAttribute('data-product-id') || '',
      variantId: card.getAttribute('data-product-variant-id') || '',
      productUrl: card.getAttribute('data-product-url') || '',
      title: card.getAttribute('data-product-title') || '',
      image: card.getAttribute('data-product-image') || '',
      tracks: tracks,
      startIndex: 0
    };
  }

 function openCardPlayerFromButton(button) {
  var config = getCardOpenConfig(button);
  if (!config) return false;

  whenYouTubeReady(function () {
    var player = ensureBottomPlayer();

    if (
      String(player.currentProductId) === String(config.productId) &&
      player.yt &&
      typeof player.yt.getPlayerState === 'function'
    ) {
      var state = player.yt.getPlayerState();

      if (
        state === YT.PlayerState.PLAYING ||
        state === YT.PlayerState.BUFFERING
      ) {
        player.yt.pauseVideo();
      } else {
        player.yt.playVideo();
      }
    } else {
      player.open(config);
    }
  });

  return true;
}

  /* Public fallback used directly by the card button. This avoids relying on
     bubbling through Shopify's product-card listeners. */
  window.ExperimentalBassPlayCard = function(button, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    return openCardPlayerFromButton(button);
  };
  /* Precalentar YouTube para que el play suene al instante */
  var ebWarmedUp = false;
  function ebWarmUp() {
    if (ebWarmedUp) return;
    ebWarmedUp = true;
    whenYouTubeReady(function () {});
  }
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(ebWarmUp, { timeout: 2000 });
  } else {
    setTimeout(ebWarmUp, 1500);
  }
  function ebWarmOnIntent(e) {
    if (e.target && e.target.closest && e.target.closest('.eb-card-audio')) ebWarmUp();
  }
  document.addEventListener('pointerover', ebWarmOnIntent, { passive: true });
  document.addEventListener('touchstart', ebWarmOnIntent, { passive: true });

  function syncCardAudioOverlay(card) {
    if (!card) return;
    /* The overlay now lives directly inside .card__media and fills it.
       Do not calculate pixel offsets: Dawn already sizes .card__media. */
    card.style.top = '0';
    card.style.left = '0';
    card.style.width = '100%';
    card.style.height = '100%';
  }

  function setupCardAudio(card) {
    if (!card || card.dataset.ebCardReady === 'true') return;
    var source = card.querySelector('[data-eb-card-description]');
        if (source && source.tagName === 'TEMPLATE') {
      var ebTmp = document.createElement('div');
      ebTmp.appendChild(source.content.cloneNode(true));
      source = ebTmp;
    }

    var button = card.querySelector('[data-eb-card-play]');
    if (!source || !button) return;
    syncCardAudioOverlay(card);
    var tracks = getCardTracks(source);
    if (!tracks.length) return;
    card.dataset.ebCardReady = 'true';
    var item = {container:card, button:button, player:null};
    ebCardPlayers.push(item);

    button.addEventListener('pointerdown', function(event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }, true);
    button.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      openCardPlayerFromButton(button);
    }, true);
  }

  var ebCardDelegatedClickReady = false;
  var ebPendingCardOpen = null;

  function initializeCardDelegatedClick() {
    if (ebCardDelegatedClickReady) return;
    ebCardDelegatedClickReady = true;

    function isCardButtonTarget(event) {
      var path = event.composedPath ? event.composedPath() : [];
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (node && node.nodeType === 1 && node.matches && node.matches('[data-eb-card-play]')) return node;
      }
      return event.target && event.target.closest ? event.target.closest('[data-eb-card-play]') : null;
    }

    function intercept(event) {
      var button = isCardButtonTarget(event);
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      if (event.type === 'click') openCardPlayerFromButton(button);
    }

    document.addEventListener('click', intercept, true);
  }

  function initializeCardAudio() {
    document.querySelectorAll('[data-eb-card-audio]').forEach(setupCardAudio);
  }

  var ebCardOverlayResizeReady = false;
  function initializeCardOverlayResize() {
    if (ebCardOverlayResizeReady) return;
    ebCardOverlayResizeReady = true;
    var syncAll = function() {
      document.querySelectorAll('[data-eb-card-audio]').forEach(syncCardAudioOverlay);
    };
    window.addEventListener('resize', syncAll, {passive:true});
    window.addEventListener('load', syncAll, {passive:true});
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(syncAll);
      var root = document.querySelector('main') || document.body;
      ro.observe(root);
    }
  }

  function initialize() {
    initializeCardAudio();
    if (!window.YT || !window.YT.Player) return;
    initializeCardOverlayResize();

    document.querySelectorAll('[data-eb-mini]').forEach(function (container) {
      if (container.dataset.ebInitialized === 'true') return;

      var tracks = assignSources(container);

      if (!tracks.length) return;

      container.dataset.ebInitialized = 'true';

      tracks.forEach(setupTrack);
    });
  }

  function loadYouTubeAPI() {
    if (window.YT && window.YT.Player) {
      initialize();
      if (ebPendingCardOpen) {
        var pendingNow = ebPendingCardOpen;
        ebPendingCardOpen = null;
        setTimeout(function(){ ensureBottomPlayer().open(pendingNow); }, 0);
      }
      return;
    }

    var oldCallback = window.onYouTubeIframeAPIReady;

    window.onYouTubeIframeAPIReady = function () {
      if (typeof oldCallback === 'function') {
        try {
          oldCallback();
        } catch (e) {}
      }

      initialize();
      if (ebPendingCardOpen) {
        var pending = ebPendingCardOpen;
        ebPendingCardOpen = null;
        setTimeout(function(){ ensureBottomPlayer().open(pending); }, 0);
      }
    };

    if (
      document.querySelector(
        'script[src="https://www.youtube.com/iframe_api"]'
      )
    ) {
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true;

    document.head.appendChild(script);
  }

  function boot() {
    initializeCardDelegatedClick();
    /*
     * Shopify can replace product HTML during variant changes / quick view.
     * A small delay plus a MutationObserver lets the player initialize again
     * without duplicating already initialized players.
     */
    setTimeout(initialize, 50);
    setTimeout(initialize, 500);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        setTimeout(initialize, 50);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  function start() {
    /* Lazy-load YouTube only after the customer asks to hear something. */
    boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
